import { PDFDownloadLink } from "@react-pdf/renderer";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { LiaClipboardListSolid } from "react-icons/lia";
import { TbNotes } from "react-icons/tb";
import {
  LuArrowLeft, LuPencil, LuSend, LuDownload,
  LuTrash2, LuLink, LuCopy, LuRefreshCw,
  LuPackage, LuFileText, LuCalendar, LuUser, LuTruck
} from "react-icons/lu";
import { Button, Card, Modal } from "react-bootstrap";
import { Scrollbars } from 'react-custom-scrollbars-2';
import { getIndividualnvoice, deleteInvoice, resendInvoice, payInvoiceManually } from "../../../redux/reducers/invoiceSlice";
import { getShipmentList } from "../../../redux/reducers/shipmentSlice";
import InvoicePdf from "./InvoicePdf";
import CreateShipmentModal from "../../Shipment/partials/CreateShipmentModal";
import { formatCurrency } from "../../../utils/currency";

import signature from "../../../assets/images/signature.png";

export default function ViewInvoice() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [deletemodalshow, setDeletemodalshow] = useState(false);
  const handledeleteClose = () => setDeletemodalshow(false);
  const handledeleteShow = () => setDeletemodalshow(true);

  const [payModalShow, setPayModalShow] = useState(false);
  const [paymentNote, setPaymentNote] = useState("");
  const [copied, setCopied] = useState(false);

  const [shipmentModalShow, setShipmentModalShow] = useState(false);
  const [activeShipment, setActiveShipment] = useState(null);
  const businessId = useSelector(state => state.auth.userDetail?.primaryBusinessId) || localStorage.getItem("activeBusinessId");

  useEffect(() => {
    dispatch(getIndividualnvoice(id));
  }, [dispatch, id]);

  const currency = useSelector((state) => state.business?.currencyContext?.currency || 'CAD');

  useEffect(() => {
    if (businessId && id) {
      dispatch(getShipmentList({ businessId, filters: { invoiceId: id } }))
        .then(res => {
          if (res.payload?.data?.list?.length > 0) {
            setActiveShipment(res.payload.data.list[0]);
          }
        });
    }
  }, [dispatch, businessId, id]);

  const invoicedata = useSelector((state) => state.invoice.individualInvoice);
  console.log(invoicedata);
  const handleDelete = () => {
    dispatch(deleteInvoice(id)).then((res) => {
      if (!res.error) {
        setDeletemodalshow(false);
        navigate("/invoice");
      }
    });
  };

  const handleResend = () => {
    dispatch(resendInvoice(id));
  };

  const handleEdit = () => {
    navigate(`/create-invoice?edit=true&id=${id}`);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(invoicedata?.paymentUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handlePayManually = () => {
    dispatch(payInvoiceManually({ id, note: paymentNote })).then(res => {
      if (!res.error) {
        setPayModalShow(false);
        setPaymentNote("");
      }
    });
  };

  const getStatusBadge = (status) => {
    const s = status?.toLowerCase();
    const map = {
      paid: { bg: "#d1fae5", color: "#10b981" },
      sent: { bg: "#e0f2fe", color: "#0ea5e9" },
      draft: { bg: "#fef3c7", color: "#f59e0b" },
      cancelled: { bg: "#fee2e2", color: "#ef4444" },
    };
    const style = map[s] || { bg: "#f1f5f9", color: "#64748b" };
    return (
      <span
        className="rounded-pill px-3 py-1 fw-bold text-capitalize"
        style={{ fontSize: "13px", background: style.bg, color: style.color }}
      >
        {status}
      </span>
    );
  };

  const getRecurringText = () => {
    const r = invoicedata?.recurring;
    if (!r?.isRecurring) return null;
    const isCustom = r.interval === "custom";
    const intervalText = isCustom
      ? `every ${r.custom?.frequencyValue} ${r.custom?.frequencyType}`
      : `every ${r.interval}`;
    switch (r.recurrenceEndType) {
      case "numberOfInvoices": return `Recurring ${intervalText} · ${r.numberOfInvoices} total billings`;
      case "endDate": return `Recurring ${intervalText} until ${moment(r.endDate).format("MMM D, YYYY")}`;
      case "continuous": return `Recurring ${intervalText} indefinitely`;
      default: return null;
    }
  };

  const infoRow = (label, value) => (
    <div className="mb-2">
      <div className="text-muted" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px" }}>
        {label}
      </div>
      <div className="fw-semibold text-dark" style={{ fontSize: "13px" }}>{value || "—"}</div>
    </div>
  );
  const fmt = (val) => formatCurrency(val, currency);
  return (
    <>
      <div className="container-fluid my-4">
        {/* Page Title */}
        <div className="d-flex align-items-center gap-3 mb-4">
          <button className="btn btn-light rounded-circle p-2" onClick={() => navigate("/invoice")}>
            <LuArrowLeft size={16} />
          </button>
          <div>
            <h5 className="fw-bold text-dark mb-0">Invoice Detail</h5>
            <div className="text-muted" style={{ fontSize: "11px" }}>
              #{invoicedata?._id?.slice(-10).toUpperCase()}
            </div>
          </div>
          <div className="ms-auto">{getStatusBadge(invoicedata?.status)}</div>
        </div>

        {/* Main Invoice Content (Left section) */}
        <div className="row">
          {/* Invoice Details */}
          <div className="col-12 col-md-8">

            {/* Business + Invoice Meta */}
            <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "24px" }}>
              <div className="d-flex align-items-start justify-content-between mb-4">
                <div>
                  <div className="fw-bold text-dark" style={{ fontSize: "20px" }}>
                    {invoicedata?.business?.name}
                  </div>
                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    {invoicedata?.business?.contact?.email}
                  </div>
                </div>
                <div
                  className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ width: 44, height: 44, background: "rgba(40,176,196,0.1)", color: "#28B0C4" }}
                >
                  <LuFileText size={20} />
                </div>
              </div>

              {/* Invoice meta pills */}
              <div className="d-flex flex-wrap gap-2 mb-4">
                <span className="d-inline-flex align-items-center gap-1 rounded-pill px-3 py-1 border" style={{ fontSize: "12px", color: "#64748b" }}>
                  <LuFileText size={12} /> #{invoicedata?._id?.slice(-8).toUpperCase()}
                </span>
                <span className="d-inline-flex align-items-center gap-1 rounded-pill px-3 py-1 border" style={{ fontSize: "12px", color: "#64748b" }}>
                  <LuCalendar size={12} /> Issued: {moment(invoicedata?.invoiceDate).format("MMM D, YYYY")}
                </span>
                <span className="d-inline-flex align-items-center gap-1 rounded-pill px-3 py-1 border" style={{ fontSize: "12px", color: "#64748b" }}>
                  <LuCalendar size={12} /> Due: {moment(invoicedata?.invoiceDueDate).format("MMM D, YYYY")}
                </span>
              </div>

              {/* Bill From / Bill To */}
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="rounded-3 p-3 h-100" style={{ background: "#f8fafc", border: "1.5px solid #f1f5f9" }}>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <LuUser size={13} className="text-muted" />
                      <span className="fw-bold text-muted" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.4px" }}>Bill From</span>
                    </div>
                    <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>{invoicedata?.business?.name}</div>
                    <div className="text-muted" style={{ fontSize: "12px", lineHeight: 1.7 }}>
                      {invoicedata?.business?.location}<br />
                      {[invoicedata?.business?.addressInfo?.city, invoicedata?.business?.addressInfo?.state, invoicedata?.business?.addressInfo?.zipCode].filter(Boolean).join(", ")}<br />
                      {invoicedata?.business?.addressInfo?.country}<br />
                      {invoicedata?.business?.contact?.email}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="rounded-3 p-3 h-100" style={{ background: "#f8fafc", border: "1.5px solid #f1f5f9" }}>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <LuUser size={13} className="text-muted" />
                      <span className="fw-bold text-muted" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.4px" }}>Bill To</span>
                    </div>
                    <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>{invoicedata?.customer?.name}</div>
                    <div className="text-muted" style={{ fontSize: "12px", lineHeight: 1.7 }}>
                      {typeof invoicedata?.customer?.address === "object"
                        ? [invoicedata?.customer?.address?.street, invoicedata?.customer?.address?.city, invoicedata?.customer?.address?.state, invoicedata?.customer?.address?.zipCode, invoicedata?.customer?.address?.country].filter(Boolean).join(", ")
                        : invoicedata?.customer?.address}
                      <br />{invoicedata?.customer?.email}
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            {/* ── Line Items Table ── */}
            <Card className="border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
              <div className="px-4 pt-4 pb-2 d-flex align-items-center gap-2">
                <div className="rounded-2" style={{ width: 4, height: 18, background: "#28B0C4" }} />
                <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Line Items</h6>
              </div>
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead className="bg-light text-muted small text-uppercase">
                    <tr>
                      <th className="ps-4 py-3 fw-semibold">Item</th>
                      <th className="fw-semibold">Qty</th>
                      <th className="fw-semibold">Rate</th>
                      <th className="fw-semibold">Discount</th>
                      <th className="fw-semibold">Tax</th>
                      <th className="pe-4 text-end fw-semibold">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoicedata?.productDetail?.map((item, idx) => (
                      <tr key={idx}>
                        <td className="ps-4 py-3">
                          <div className="d-flex align-items-center gap-2">
                            <div className="p-2 bg-light rounded-3">
                              <LuPackage size={14} className="text-muted" />
                            </div>
                            <span className="fw-semibold small">{item?.productName || item?.name}</span>
                          </div>
                        </td>
                        <td><span className="small fw-semibold">{item?.quantity}</span></td>
                        <td><span className="small">{fmt(item?.rate || item?.unitPrice)}</span></td>
                        <td>
                          {item?.discountamount > 0
                            ? <span className="small text-danger">-{fmt(item?.discountamount)}</span>
                            : <span className="text-muted small">—</span>}
                        </td>
                        <td>
                          {item?.tax > 0
                            ? <span className="small text-success">+{fmt(item?.tax)}</span>
                            : <span className="text-muted small">—</span>}
                        </td>
                        <td className="pe-4 text-end">
                          <span className="fw-bold small" style={{ color: "#28B0C4" }}>{fmt(item?.total)}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Totals */}
              <div className="px-4 py-4 border-top">
                <div className="row justify-content-end">
                  <div className="col-md-5">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex justify-content-between small">
                        <span className="text-muted">Subtotal</span>
                        <span className="fw-semibold">{fmt(invoicedata?.netAmount)}</span>
                      </div>
                      {invoicedata?.productDetail?.some(p => p.discountamount > 0) && (
                        <div className="d-flex justify-content-between small">
                          <span className="text-muted">Line Discounts</span>
                          <span className="fw-semibold text-danger">-{fmt(invoicedata?.invoiceDiscount)}</span>
                        </div>
                      )}
                      {invoicedata?.appliedDiscounts?.map((d, di) => (
                        <div key={di} className="d-flex justify-content-between small">
                          <span className="text-muted">{d.name}</span>
                          <span className="fw-semibold text-danger">-{fmt(d.amount)}</span>
                        </div>
                      ))}
                      {invoicedata?.appliedTaxes?.map((tax, ti) => (
                        <div key={ti} className="d-flex justify-content-between small">
                          <span className="text-muted">{tax.name} ({tax.percentage}%)</span>
                          <span className="fw-semibold text-success">+{fmt(tax.amount)}</span>
                        </div>
                      ))}
                      {invoicedata?.shippingCharge > 0 && (
                        <div className="d-flex justify-content-between small">
                          <span className="text-muted">Shipping</span>
                          <span className="fw-semibold">+{fmt(invoicedata?.shippingCharge)}</span>
                        </div>
                      )}
                      <div
                        className="d-flex justify-content-between align-items-center rounded-3 px-3 py-2 mt-1"
                        style={{ background: "rgba(40,176,196,0.08)", border: "1.5px solid rgba(40,176,196,0.2)" }}
                      >
                        <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>Grand Total</span>
                        <span className="fw-bold" style={{ fontSize: "18px", color: "#28B0C4" }}>
                          {fmt(invoicedata?.totalAmount)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            {/* ── Terms, Notes, Recurring ── */}
            <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "20px 24px" }}>
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <LiaClipboardListSolid size={16} className="text-muted" />
                    <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>Terms & Conditions</span>
                  </div>
                  <div className="text-muted rounded-3 p-3" style={{ fontSize: "13px", background: "#f8fafc", border: "1.5px solid #f1f5f9", minHeight: "60px" }}>
                    {invoicedata?.terms || "No terms specified."}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <TbNotes size={16} className="text-muted" />
                    <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>Notes</span>
                  </div>
                  <div className="text-muted rounded-3 p-3" style={{ fontSize: "13px", background: "#f8fafc", border: "1.5px solid #f1f5f9", minHeight: "60px" }}>
                    {invoicedata?.notes || "No notes added."}
                  </div>
                </div>
              </div>

              {invoicedata?.recurring?.isRecurring && getRecurringText() && (
                <div
                  className="d-flex align-items-center gap-2 rounded-3 p-3 mt-4"
                  style={{ background: "rgba(40,176,196,0.06)", border: "1.5px solid rgba(40,176,196,0.2)" }}
                >
                  <LuRefreshCw size={14} style={{ color: "#28B0C4", flexShrink: 0 }} />
                  <span className="fw-semibold" style={{ fontSize: "13px", color: "#28B0C4" }}>
                    {getRecurringText()}
                  </span>
                </div>
              )}

              <div className="mt-4 pt-3 border-top">
                <div className="text-muted fw-semibold mb-2" style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.4px" }}>
                  Authorised Signature
                </div>
                <img src={signature} alt="signature" className="signaute-img" style={{ maxHeight: "60px" }} />
              </div>
            </Card>
          </div>

          {/* Sidebar (Right section) */}
          <div className="col-12 col-md-4 mt-4 mt-md-0">
            {/* Actions */}
            <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "20px" }}>
              <div className="d-flex align-items-center gap-2 mb-3">
                <div className="rounded-2" style={{ width: 4, height: 18, background: "#28B0C4" }} />
                <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Actions</h6>
              </div>
              <div className="d-flex flex-column gap-2">
                <button
                  className="btn rounded-3 fw-semibold d-flex align-items-center gap-2 text-white w-100"
                  style={{ fontSize: "13px", background: "#28B0C4", border: "none", padding: "10px 16px" }}
                  onClick={handleEdit}
                >
                  <LuPencil size={14} /> Edit Invoice
                </button>
                {invoicedata?.status?.toLowerCase() !== 'paid' && (
                  <button
                    className="btn rounded-3 fw-semibold d-flex align-items-center gap-2 text-white w-100"
                    style={{ fontSize: "13px", background: "#10b981", border: "none", padding: "10px 16px" }}
                    onClick={() => setPayModalShow(true)}
                  >
                    <LuFileText size={14} /> Mark as Paid
                  </button>
                )}
                <button
                  className="btn btn-light rounded-3 fw-semibold d-flex align-items-center gap-2 w-100"
                  style={{ fontSize: "13px", padding: "10px 16px" }}
                  onClick={handleResend}
                >
                  <LuSend size={14} /> Resend Invoice
                </button>
                <button
                  className="btn btn-light rounded-3 fw-semibold d-flex align-items-center gap-2 w-100"
                  style={{ fontSize: "13px", padding: "10px 16px" }}
                >
                  <LuDownload size={14} />
                  {invoicedata ? (
                    <PDFDownloadLink
                      key={invoicedata?._id}
                      document={<InvoicePdf data={invoicedata} />}
                      fileName={`invoice_${invoicedata?._id}.pdf`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {({ loading }) => (loading ? "Preparing PDF..." : "Download PDF")}
                    </PDFDownloadLink>
                  ) : (
                    <span>Download PDF</span>
                  )}
                </button>
                <button
                  className="btn rounded-3 fw-semibold d-flex align-items-center gap-2 w-100"
                  style={{ fontSize: "13px", padding: "10px 16px", background: "#fee2e2", color: "#ef4444", border: "none" }}
                  onClick={() => setDeletemodalshow(true)}
                >
                  <LuTrash2 size={14} /> Delete Invoice
                </button>
              </div>
            </Card>

            {/* Shipment Tracking Card */}
            {activeShipment ? (
              <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "20px" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="rounded-2" style={{ width: 4, height: 18, background: "#28B0C4" }} />
                  <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Shipment Tracking</h6>
                </div>
                <div className="mb-3 d-flex justify-content-between align-items-center">
                  <span className="small text-muted">{activeShipment.trackingCode}</span>
                  <span className="badge" style={{ background: "rgba(40,176,196,0.1)", color: "#28B0C4" }}>
                    {activeShipment.status}
                  </span>
                </div>
                <button
                  className="btn rounded-3 fw-semibold w-100 d-flex align-items-center justify-content-center gap-2"
                  style={{ fontSize: "13px", background: "#f8fafc", color: "#64748b", border: "1.5px solid #e2e8f0", padding: "9px" }}
                  onClick={() => navigate(`/shipment/${activeShipment._id}`)}
                >
                  <LuTruck size={14} /> View Tracking
                </button>
              </Card>
            ) : (
               <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "20px" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="rounded-2" style={{ width: 4, height: 18, background: "#28B0C4" }} />
                  <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Shipment & Delivery</h6>
                </div>
                <button
                  className="btn rounded-3 fw-semibold w-100 d-flex align-items-center justify-content-center gap-2"
                  style={{ fontSize: "13px", background: "#f8fafc", color: "#28B0C4", border: "1.5px dashed #28B0C4", padding: "9px" }}
                  onClick={() => setShipmentModalShow(true)}
                >
                  <LuTruck size={14} /> Create Shipment
                </button>
              </Card>
            )}

            {/* Payment Link */}
            {invoicedata?.paymentUrl && (
              <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "20px" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="rounded-2" style={{ width: 4, height: 18, background: "#10b981" }} />
                  <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Payment Link</h6>
                </div>

                {/* Truncated URL display */}
                <div
                  className="rounded-3 p-2 mb-2 d-flex align-items-center gap-2"
                  style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0" }}
                >
                  <LuLink size={12} style={{ color: "#10b981", flexShrink: 0 }} />
                  <span style={{
                    fontSize: "11px",
                    color: "#64748b",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "180px",
                    display: "block"
                  }}>
                    {invoicedata.paymentUrl}
                  </span>
                </div>

                {/* Action buttons stacked */}
                <div className="d-flex flex-column gap-2">

                  <a href={invoicedata.paymentUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="btn rounded-3 fw-semibold w-100 d-flex align-items-center justify-content-center gap-2"
                    style={{ fontSize: "13px", background: "rgba(16,185,129,0.1)", color: "#10b981", border: "none", padding: "9px" }}
                  >
                    <LuLink size={13} /> Open Payment Page
                  </a>
                  <button
                    className="btn rounded-3 fw-semibold w-100 d-flex align-items-center justify-content-center gap-2"
                    style={{
                      fontSize: "13px",
                      background: copied ? "rgba(16,185,129,0.08)" : "#f8fafc",
                      color: copied ? "#10b981" : "#64748b",
                      border: "1.5px solid #e2e8f0",
                      padding: "9px"
                    }}
                    onClick={handleCopy}
                  >
                    <LuCopy size={13} />
                    {copied ? "Copied to clipboard!" : "Copy Payment Link"}
                  </button>
                </div>
              </Card>
            )}
            {/* Summary */}
            <Card className="border-0 shadow-sm rounded-4 mb-4" style={{ padding: "20px" }}>
              <div className="d-flex align-items-center gap-2 mb-3">
                <div className="rounded-2" style={{ width: 4, height: 18, background: "#28B0C4" }} />
                <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Summary</h6>
              </div>
              <div className="d-flex flex-column gap-2">
                {infoRow("Invoice ID", `#${invoicedata?._id?.slice(-8).toUpperCase()}`)}
                {infoRow("Status", getStatusBadge(invoicedata?.status))}
                {infoRow("Issued", moment(invoicedata?.invoiceDate).format("MMM D, YYYY"))}
                {infoRow("Due Date", moment(invoicedata?.invoiceDueDate).format("MMM D, YYYY"))}
                {infoRow("Customer", invoicedata?.customer?.name)}
                {infoRow("Currency", invoicedata?.currency)}
                <div
                  className="d-flex justify-content-between align-items-center rounded-3 px-3 py-2 mt-1"
                  style={{ background: "rgba(40,176,196,0.08)", border: "1.5px solid rgba(40,176,196,0.2)" }}
                >
                  <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>Total</span>
                  <span className="fw-bold" style={{ fontSize: "16px", color: "#28B0C4" }}>
                    {fmt(invoicedata?.totalAmount)}
                  </span>
                </div>
              </div>
            </Card>

            {/* Activity Timeline */}
            <Card className="border-0 shadow-sm rounded-4" style={{ padding: "20px" }}>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "14px" }}>Invoice Activity</h6>
                  <div className="text-muted" style={{ fontSize: "11px" }}>Full history of this invoice</div>
                </div>
                <span
                  className="rounded-pill px-2 py-1 fw-semibold"
                  style={{ fontSize: "11px", background: "rgba(40,176,196,0.1)", color: "#28B0C4" }}
                >
                  {invoicedata?.activity?.length
                    ? `${invoicedata.activity.length} events`
                    : `${[invoicedata?.createdAt, invoicedata?.sentAt, invoicedata?.paidAt].filter(Boolean).length} events`}
                </span>
              </div>

              <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={380}>
                <div className="timeline-container">
                  {invoicedata?.activity && invoicedata.activity.length > 0 ? (
                    invoicedata.activity
                      .slice()
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((act, index) => (
                        <div key={act._id || index} className="timeline-item">
                          <div className="timeline-marker" />
                          <div className="timeline-content">
                            <div className="timeline-action-badge">{act.action}</div>
                            <h6>{act.action}</h6>
                            <div className="timeline-date">
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                              </svg>
                              {moment(act.date).format("MMM D, YYYY [at] HH:mm")}
                            </div>
                            {act.details && <div className="timeline-details">{act.details}</div>}
                          </div>
                        </div>
                      ))
                  ) : (
                    <>
                      <div className="timeline-item">
                        <div className="timeline-marker" />
                        <div className="timeline-content">
                          <div className="timeline-action-badge">Created</div>
                          <h6>Invoice Created</h6>
                          <div className="timeline-date">
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                            </svg>
                            {moment(invoicedata?.createdAt).format("MMM D, YYYY [at] HH:mm")}
                          </div>
                        </div>
                      </div>
                      {invoicedata?.sentAt && (
                        <div className="timeline-item">
                          <div className="timeline-marker" />
                          <div className="timeline-content">
                            <div className="timeline-action-badge" style={{ background: "rgba(99,102,241,0.1)", color: "#6366f1" }}>Sent</div>
                            <h6>Invoice Sent</h6>
                            <div className="timeline-date">
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                              </svg>
                              {moment(invoicedata?.sentAt).format("MMM D, YYYY [at] HH:mm")}
                            </div>
                          </div>
                        </div>
                      )}
                      {invoicedata?.paidAt && (
                        <div className="timeline-item">
                          <div className="timeline-marker" />
                          <div className="timeline-content">
                            <div className="timeline-action-badge" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}>Paid</div>
                            <h6>Invoice Paid</h6>
                            <div className="timeline-date">
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                              </svg>
                              {moment(invoicedata?.paidAt).format("MMM D, YYYY [at] HH:mm")}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Scrollbars>
            </Card>
          </div>
        </div>
      </div >

      <Modal
        show={deletemodalshow}
        onHide={handledeleteClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Delete Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center py-3">
            <p className="mb-0">Are you sure you want to delete this invoice?</p>
            <p className="text-muted small">This action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" onClick={handledeleteClose} className="fw-bold">
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            className="fw-bold px-4"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={payModalShow}
        onHide={() => setPayModalShow(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Mark as Paid</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label small fw-bold text-muted">Payment Note (Optional)</label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="e.g. Received via Cash / Bank Transfer"
              value={paymentNote}
              onChange={(e) => setPaymentNote(e.target.value)}
            ></textarea>
          </div>
          <p className="small text-muted mb-0">
            This will mark the invoice and any associated order as <strong>Paid</strong>.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" onClick={() => setPayModalShow(false)} className="fw-bold">
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handlePayManually}
            className="fw-bold px-4"
          >
            Confirm Payment
          </Button>
        </Modal.Footer>
      </Modal>

      <CreateShipmentModal
        show={shipmentModalShow}
        onHide={() => setShipmentModalShow(false)}
        invoice={invoicedata}
        onSuccess={(shipment) => setActiveShipment(shipment)}
      />
    </>
  );
}
